import { RootState } from "../store";

// Boolean selectors for specific login statuses
export const selectLoginStatus = (state: RootState) => state.auth.loginStatus;
export const selectIsAuthPending = (state: RootState) =>
  state.auth.loginStatus === "pending";
export const selectIsAuthSuccess = (state: RootState) =>
  state.auth.loginStatus === "success";

// Combined selectors
export const selectIsAuthSuccessOrPerpetual = (state: RootState) =>
  state.auth.loginStatus === "success" ||
  state.auth.loginStatus === "perpetual";
export const selectLeadStatus = (state: RootState) => state.auth.leadStatus;

export const selectIsCommonSsoModalVisible = (state: RootState) =>
  state.auth.isCommonSsoModalVisible;
